import { IFINANCE_ID, MEDICARD_ID } from '../data/merchant-selectors'

export const isMedicardWebSite = () => {
  return window.location.hostname.includes('medicard.com')
}

export function getDefaultMerchantIdFromHostname() {
  if (isMedicardWebSite()) return MEDICARD_ID

  return IFINANCE_ID
}

export function getIdsFromUrl() {
  const ret = {
    creditAppId: '',
    merchantId: getDefaultMerchantIdFromHostname(),
  }

  const pathParts = window.location.pathname.split('/').filter((x) => !!x)
  const isCreditApp = pathParts.length >= 2 && pathParts[0].toLocaleLowerCase() === 'creditapplication'

  if (isCreditApp) {
    ret.creditAppId = pathParts[1]
  } else if (pathParts.length > 0) {
    ret.merchantId = pathParts[0]
  }

  return ret
}
